export enum WeddingWebsiteActionTypes {
  INIT_LISTENER = '[WeddingWebsite] Init listener',
  STOP_LISTENER = '[WeddingWebsite] Stop listener',
}
